import _ from 'underscore';
import { UpdateSiteLogoFormSpecs } from '../../siteLogo/forms/UpdateSiteLogoForm';
import { ActiveDirectorySyncSectionSpecs } from './sections/ActiveDirectorySyncSection';
import { AskDataSectionSpecs } from './sections/AskDataSection';
import { AutomaticAccessSectionSpecs } from './sections/AutomaticAccessSection';
import { AutoSuspendExtractRefreshSectionSpecs } from './sections/AutoSuspendExtractRefreshSection';
import { CacheWarmupSectionSpecs } from './sections/CacheWarmupSection';
import { CatalogingSectionSpecs } from './sections/CatalogingSection';
import { CollectionsSectionSpecs } from './sections/CollectionsSection';
import { CommentingSettingSectionSpecs } from './sections/CommentingSettingSection';
import { ConnectedClientsSettingSectionSpecs } from './sections/ConnectedClientsSettingSection';
import { CrossDataBaseJoinsSectionSpecs } from './sections/CrossDataBaseJoinsSection';
import { DataAccelerationSpecs } from './sections/data-acceleration/DataAccelerationSection';
import { DataAlertsSectionSpecs } from './sections/DataAlertsSection';
import { EmailSettingsSpecs } from './sections/EmailSettingsSection';
import { ExtractEncryptionSectionSpecs } from './sections/ExtractEncryptionSection';
import { ServerGuestAccessSectionSpecs, SiteGuestAccessSectionSpecs } from './sections/GuestAccessSection';
import { ManageUsersSectionSpecs } from './sections/manage-users-section/ManageUsersSection';
import { ManagedKeychainCleanupSectionSpecs } from './sections/ManagedKeychainCleanup';
import { MetricsContentTypeSpecs } from './sections/MetricsContentTypeSection';
import { MobileSectionSpecs } from './sections/MobileSection';
import { NotificationFlowRunsSpecs } from './sections/NotificationsFlowRunsSection';
import { NotifySiteAdminsOnThrottleSpec } from './sections/NotifySiteAdminsOnThrottleSection';
import { OAuthClientsRegistrySectionSpecs } from './sections/oauth-clients-registry/OAuthClientsRegistry';
import { PerformanceMetricsSectionSpecs } from './sections/PerformanceMetricsSection';
import { PersonalSpaceSectionSpecs } from './sections/personal-space-section/PersonalSpaceSection';
import { PrepConductorSpecs } from './sections/PrepConductorSection';
import { RequestAccessSectionSpecs } from './sections/RequestAccessSection';
import { RevisionHistorySectionSpecs } from './sections/revision-history/RevisionHistorySection';
import { RunNowSpec } from './sections/RunNowSection';
import { SavedCredentialsSpecs } from './sections/SavedCredentialsSection';
import { SensitiveLineageDataSectionSpecs } from './sections/SensitiveLineageDataSection';
import { SharingSectionSpecs } from './sections/SharingSection';
import { SiteNameAndIdSpecs } from './sections/site-name-and-id/SiteNameAndIdSection';
import { SiteAvailabilitySpecs } from './sections/SiteAvailabilitySection';
import { SiteInviteNotificationSpecs } from './sections/SiteInviteNotificationSection';
import { SiteTimeZoneSectionSpecs } from './sections/SiteTimeZoneSection';
import { ServerStartPageSpecs, SiteStartPageSpecs } from './sections/StartPageSection';
import { StorageSectionSpecs } from './sections/storage/StorageSection';
import { SubscriptionsSpec } from './sections/SubscriptionsSection';
import { SupportAccessSectionSpecs } from './sections/SupportAccessSection';
import { UserNotificationsSiteSettingsSectionSpecs } from './sections/UserNotificationsSiteSettingsSection';
import { UserVisibilitySpecs } from './sections/UserVisibilitySection';
import { VizRecommendationsSectionSpecs } from './sections/VizRecommendationsSection';
import { WebAuthoringSpecs } from './sections/WebAuthoringSection';
import { WebPageObjectsSectionSpecs } from './sections/WebPageObjectsSection';
import { ComponentSpecs } from './SettingsComponentRegistryFunctions';
import { SignInNoteSpec } from './sections/SignInNoteSection';
import { RecommendationsTrainingSectionSpecs } from './sections/RecommendationsTrainingSection';
import { LanguageAndLocaleSectionSpecs } from './sections/LanguageAndLocaleSection';
import { EmbeddedCredentialsSectionSpecs } from './sections/EmbeddedCredentialsSection';
import { BridgeSettingsSummarySectionSpecs } from '~src/settings/general-settings/components/sections/bridge/BridgeSettingsSummarySection';
import { BridgeClientNotRunningNotificationsSectionSpecs } from '~src/settings/general-settings/components/sections/bridge/BridgeClientNotRunningNotificationsSection';
import { BridgePoolingSectionSpecs } from '~src/settings/general-settings/components/sections/bridge/BridgePoolingSection';
import { BridgeRemoteAgentsSectionSpecs } from '~src/settings/general-settings/components/sections/bridge/BridgeRemoteAgentsSection';
import { ExtensionsServerSectionSpecs } from './extensions-settings/dashboard/ExtensionsServerSection';
import { ExtensionsSiteSectionSpecs } from './extensions-settings/dashboard/ExtensionsSiteSection';
import { PrepExtensionsSiteSectionSpecs } from '~src/settings/general-settings/components/extensions-settings/prep/PrepExtensionsSiteSection';
import {AnalyticsExtensionsSiteSectionSpec} from '~src/settings/general-settings/components/extensions-settings/analytics/AnalyticsExtensionsSiteSection';
import {AnalyticsExtensionsServerSectionSpec} from '~src/settings/general-settings/components/extensions-settings/analytics/AnalyticsExtensionsServerSection';

export function createComponentRegistry(...specArray: ComponentSpecs<any>[]) {
  const result: _.Dictionary<ComponentSpecs<any>> = {};
  specArray.forEach(spec => result[spec.name] = spec);
  return result;
}

/**
 * All react-based sections in the settings page should be added to this object to allow them to be named in
 * the pug file while migrating, and to dynamically load them later on
 */
export const SettingsComponentRegistry = createComponentRegistry(
  ConnectedClientsSettingSectionSpecs,
  LanguageAndLocaleSectionSpecs,
  CrossDataBaseJoinsSectionSpecs,
  SupportAccessSectionSpecs,
  CollectionsSectionSpecs,
  CommentingSettingSectionSpecs,
  RequestAccessSectionSpecs,
  DataAlertsSectionSpecs,
  VizRecommendationsSectionSpecs,
  SharingSectionSpecs,
  WebPageObjectsSectionSpecs,
  AutomaticAccessSectionSpecs,
  SiteNameAndIdSpecs,
  SiteAvailabilitySpecs,
  PrepConductorSpecs,
  WebAuthoringSpecs,
  StorageSectionSpecs,
  RevisionHistorySectionSpecs,
  ManageUsersSectionSpecs,
  ServerGuestAccessSectionSpecs,
  SiteGuestAccessSectionSpecs,
  PerformanceMetricsSectionSpecs,
  CatalogingSectionSpecs,
  CacheWarmupSectionSpecs,
  ManagedKeychainCleanupSectionSpecs,
  AutoSuspendExtractRefreshSectionSpecs,
  EmailSettingsSpecs,
  DataAccelerationSpecs,
  SiteInviteNotificationSpecs,
  UserVisibilitySpecs,
  ServerStartPageSpecs,
  SiteStartPageSpecs,
  PersonalSpaceSectionSpecs,
  SubscriptionsSpec,
  NotificationFlowRunsSpecs,
  MobileSectionSpecs,
  NotifySiteAdminsOnThrottleSpec,
  AskDataSectionSpecs,
  MetricsContentTypeSpecs,
  SensitiveLineageDataSectionSpecs,
  RunNowSpec,
  ExtractEncryptionSectionSpecs,
  UserNotificationsSiteSettingsSectionSpecs,
  SavedCredentialsSpecs,
  OAuthClientsRegistrySectionSpecs,
  ActiveDirectorySyncSectionSpecs,
  SiteTimeZoneSectionSpecs,
  SignInNoteSpec,
  UpdateSiteLogoFormSpecs,
  RecommendationsTrainingSectionSpecs,
  EmbeddedCredentialsSectionSpecs,
  BridgeSettingsSummarySectionSpecs,
  BridgeClientNotRunningNotificationsSectionSpecs,
  BridgePoolingSectionSpecs,
  BridgeRemoteAgentsSectionSpecs,
  ExtensionsServerSectionSpecs,
  ExtensionsSiteSectionSpecs,
  PrepExtensionsSiteSectionSpecs,
  AnalyticsExtensionsSiteSectionSpec,
  AnalyticsExtensionsServerSectionSpec
);
